module.exports = __webpack_public_path__ + "static/media/sand-clock.6de82101.svg";